import { render, staticRenderFns } from "./parametersetting.vue?vue&type=template&id=453cf13e&"
import script from "./parametersetting.vue?vue&type=script&lang=js&"
export * from "./parametersetting.vue?vue&type=script&lang=js&"
import style0 from "./parametersetting.vue?vue&type=style&index=0&id=453cf13e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports